import app from "~/config/app.config";
import store from "~/store";
import Stomp from "@stomp/stompjs";
import { Observable } from "rxjs";
import SockJS from "sockjs-client";
import { format as DateFormat } from "date-fns";
/**
 * 支持的消息类型
 */
export var ReminderMessageType;
(function (ReminderMessageType) {
    /**
     * 普通消息 Reminder
     */
    ReminderMessageType["Reminder"] = "REMINDER_MESSAGE";
    /**
     * 任务消息 TASK_BOX
     */
    ReminderMessageType["Task"] = "TASK_BOX";
    /**
     * 后台私有消息
     */
    ReminderMessageType["Background"] = "BACKGROUND";
    /**
     * 法务消息
     */
    ReminderMessageType["LegalTaskMessage"] = "LEGAI_TASK_MESSAGE";
})(ReminderMessageType || (ReminderMessageType = {}));
var ReminderService = /** @class */ (function () {
    /**
     * 初始化65
     */
    function ReminderService() {
        if (app.rabbitmq.socket.startsWith("ws://") ||
            app.rabbitmq.socket.startsWith("wss://")) {
            // websocket路径
            this.client = Stomp.client(app.rabbitmq.socket);
        }
        else {
            // http/https路径
            var ws = new SockJS(app.rabbitmq.socket);
            this.client = Stomp.over(ws);
        }
        // if (!app.debug) {
        //   console.log("非Debug模式,已关闭reminder日志")
        // }
        this.client.debug = function () { }; // 生产模式禁用日志消息
        this.client.connect(app.rabbitmq.username, app.rabbitmq.password, this.onConnectHandle.bind(this), this.onErrorHandle.bind(this), this.onCloseHandle.bind(this), app.rabbitmq.vhost);
    }
    /**
     * 打开消息服务
     */
    ReminderService.connect = function () {
        if (!this.mIinstance) {
            this.getInstance();
        }
        return this.mIinstance.client;
    };
    /**
     * 关闭消息服务
     */
    ReminderService.disConnect = function () {
        if (!this.mIinstance)
            return;
        if (this.mIinstance.client) {
            this.mIinstance.client.disconnect();
        }
    };
    /**
     * 获取 ReminderService 对象实例
     */
    ReminderService.getInstance = function () {
        if (!this.mIinstance) {
            this.mIinstance = new ReminderService();
        }
        return this.mIinstance;
    };
    /**
     * 添加消息监听
     * @param type
     * @param backgroundType 后台消息体,业务类型
     */
    ReminderService.prototype.addListener = function (type, backgroundType) {
        if (backgroundType) {
            // 如果有单独消息监听者
            var index = ReminderService.listenerList.findIndex(function (x) { return x.type === type && x.backgroundType === backgroundType; });
            // 删除之前监听列表存在的
            if (index > -1) {
                ReminderService.listenerList.splice(index, 1);
            }
        }
        // 添加监听方式
        return new Observable(function (observer) {
            ReminderService.listenerList.push({ type: type, observer: observer, backgroundType: backgroundType });
        });
    };
    /**
     * 处理消息open事件
     */
    ReminderService.prototype.onConnectHandle = function () {
        console.log("reminder connected !", DateFormat(Date.now(), "YYYY-MM-DD HH:mm:ss"));
        this.client.subscribe(app.rabbitmq.exchange + "/" + store.state.userData.id, this.onReminderHandle.bind(this));
    };
    /**
     * 处理消息message事件
     */
    ReminderService.prototype.onReminderHandle = function (_a) {
        var body = _a.body;
        try {
            // messageType 与后端定义好的消息体区分
            var _b = JSON.parse(body), messageType_1 = _b.messageType, data_1 = _b.data;
            if (app.debug) {
                console.log({ messageType: messageType_1, data: data_1 }, "ReminderMessage");
            }
            // 后台消息
            if (messageType_1 === ReminderMessageType.Background) {
                // 查找单独订阅此消息内容体的订阅者
                var listener = ReminderService.listenerList.find(function (x) {
                    return (x.type === ReminderMessageType.Background &&
                        x.backgroundType === data_1.backgroundType);
                });
                if (listener) {
                    listener.observer.next(data_1);
                }
            }
            else {
                // 前台所有消息都需要广播
                var receiveList = ReminderService.listenerList.filter(function (x) { return x.type === messageType_1; });
                receiveList.forEach(function (x) { return x.observer.next(data_1); });
            }
        }
        catch (ex) {
            console.log(ex.message);
        }
    };
    /**
     * 处理消息close事件
     */
    ReminderService.prototype.onCloseHandle = function () {
        var a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            a[_i] = arguments[_i];
        }
        console.log("close", a);
    };
    /**
     * 处理消息error事件
     */
    ReminderService.prototype.onErrorHandle = function () {
        var a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            a[_i] = arguments[_i];
        }
        console.log("error", a);
    };
    // 监听列表
    ReminderService.listenerList = [];
    return ReminderService;
}());
export { ReminderService };
